import { FormControl, makeStyles, List } from '@material-ui/core';
import { enContactChannelsType, IContactChannels } from 'interface/contactChannels';
import React, { useEffect, useState } from 'react';
import { getContactChannels } from 'services/contactChannelsService';
import { useAppSelector } from 'hooks/redux';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import ContactItem from './ContactItem';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { withCourseTheme } from 'decorators/withCourseTheme';
import { CourseTheme } from 'assets/themes/Course';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles<CourseTheme, { isLessonPage: boolean }>((theme) => ({
  contactChannelsRoot: {
    borderRadius: 4,
  },
  popoverPaper: {
    width: 272,
    background: theme.palette.grey[800],
  },
  btnPopover: {
    height: 48,
    width: 171,
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'initial',
    color: (props) => (props.isLessonPage ? theme.palette.common.white : theme.variables.courseTheme.text),
    borderColor: (props) => (props.isLessonPage ? theme.palette.common.white : theme.variables.courseTheme.text),
  },
  list: {
    '& > li': {
      color: theme.palette.common.white,
      cursor: 'pointer',
      '&:hover': {
        background: theme.palette.grey[900],
      },
    },
  },
}));

const ContactChannels = () => {
  const { lessonID } = useParams<{ lessonID: string }>();
  const classes = useStyles({ isLessonPage: Boolean(lessonID) });
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [listOfChannels, setListOfChannels] = useState(undefined);
  const courseId = useAppSelector((state) => state.course.id);
  const emailProducer = useAppSelector((state) => state?.course?.producer?.email);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const process = async () => {
      if (!courseId) return;
      let data = await getContactChannels(courseId);
      if (!data.some((c) => c.type === enContactChannelsType.email)) {
        data = [
          {
            type: 2,
            data: emailProducer,
            icon: MailOutlineIcon,
            name: 'E-mail de suporte',
          },
          ...data,
        ];
      }
      setListOfChannels(data);
    };
    process();
  }, [courseId, emailProducer]);

  const handleClickPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (listOfChannels === undefined) return null;

  return (
    <FormControl classes={{ root: classes.contactChannelsRoot }}>
      <Button className={classes.btnPopover} onClick={handleClickPopover} variant='outlined'>
        Canais de contato
      </Button>
      <Popover
        id={'contact-channels-popover'}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        classes={{ paper: classes.popoverPaper }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List className={classes.list}>
          {listOfChannels?.map((c: IContactChannels, index: number) => (
            <ContactItem key={index} contactChannel={c} />
          ))}
        </List>
      </Popover>
    </FormControl>
  );
};

export default withCourseTheme(ContactChannels);
